"use client";
import React from "react";

interface ImageTextSectionProps {
  title: string;
  subtitle?: string;
  description: string;
  image: string;
  imageMobile?: string;
  imageAlt: string;
  ctaText?: string;
  onCtaClick?: () => void;
  imageFirst?: boolean;
  backgroundColor?: "dark" | "light";
  rtl?: boolean;
}

const ImageTextSection: React.FC<ImageTextSectionProps> = ({
  title,
  subtitle,
  description,
  image,
  imageMobile,
  imageAlt,
  ctaText,
  onCtaClick,
  imageFirst = false,
  backgroundColor = "dark",
  rtl = false,
}) => {
  const bgClass =
    backgroundColor === "dark"
      ? "bg-neutral-900/90 text-white"
      : "bg-neutral-50/90";
  const textColor =
    backgroundColor === "dark" ? "text-neutral-300" : "text-neutral-600";

  return (
    <section className="relative">
      {/* Desktop Layout */}
      <div
        className="hidden md:block py-24 relative md:min-h-[737px]"
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/20"></div>

        <div
          className={`relative z-10 max-w-[500px] flex flex-col md:flex-row items-center gap-12 px-4 ${rtl ? "ml-auto md:mr-16" : "mr-auto md:ml-16"}`}
        >
          <div className="flex-1">
            {subtitle && (
              <h4 className="text-md text-white mb-6">{subtitle}</h4>
            )}
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-6">
              {title}
            </h2>
            <p className={`text-lg ${textColor} mb-8`}>{description}</p>
            {/* {ctaText && (
              <button
                className="px-8 py-3 border-2 text-primary-foreground rounded-full pt-[5px] pb-[5px] font-medium hover:bg-primary/90 transition-colors"
                onClick={onCtaClick}
              >
                {ctaText}
              </button>
            )} */}
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden">
        <div className="w-full h-auto relative">
          <img
            src={imageMobile || image}
            alt={imageAlt}
            className="w-full h-full object-cover min-h-[500px]"
          />
        </div>

        <div className="bg-black text-white p-12 py-18 md:px-4 md:py-8">
          <div className="max-w-[500px] mx-auto">
            {subtitle && (
              <h4 className="text-md text-white mb-6">{subtitle}</h4>
            )}
            <h2 className="text-white text-2xl font-bold mb-6">{title}</h2>
            <p className="text-lg text-neutral-300 mb-8">{description}</p>
            {/* {ctaText && (
              <button
                className="px-8 py-3 border-2 text-primary-foreground rounded-full pt-[5px] pb-[5px] font-medium hover:bg-primary/90 transition-colors"
                onClick={onCtaClick}
              >
                {ctaText}
              </button>
            )} */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageTextSection;
